// Skeleton (009 T036): a placeholder with the size of the content it stands for, so nothing jumps when data
// arrives. Hidden from screen readers; wrap a loading region with `LoadingRegion` to announce it.
import type { CSSProperties, ReactNode } from 'react';
import { cn } from '../lib/cn';

/**
 * A placeholder block.
 * @param props size classes and inline style
 * @returns the block
 */
export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return (
    <span
      aria-hidden="true"
      style={style}
      className={cn('block animate-pulse rounded-xl bg-subtle', className)}
    />
  );
}

/**
 * A region announced as loading while its placeholders show.
 * @param props the spoken label and the placeholders
 * @returns the region
 */
export function LoadingRegion({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div role="status" aria-busy="true" aria-label={label} className="flex w-full flex-col gap-3">
      {children}
    </div>
  );
}
